import { initializeAnalyticsInteractions } from "@services/tracking";

import EventDataLayer from "./queue/EventDataLayer";
import { AidenSubscriber } from "./subscribers/aiden/AidenSubscriber";
import { BazaarVoiceSubscriber } from "./subscribers/bazaarVoice/BazaarVoiceSubscriber";
import { DebugSubscriber } from "./subscribers/debugger/DebugSubscriber";
import { GoogleAnalyticsSubscriber } from "./subscribers/googleanalytics/GoogleAnalyticsSubscriber";
import CookiePolicy from "./util/CookiePolicy";

const subscribe = (withHistory = false) => {
    const eventDataLayer = EventDataLayer.getInstance();

    GoogleAnalyticsSubscriber(eventDataLayer, withHistory);
    DebugSubscriber(eventDataLayer, withHistory);
    AidenSubscriber(eventDataLayer, withHistory);
    BazaarVoiceSubscriber(eventDataLayer, withHistory);
};

const hasOnlyStrictCookies = () => {
    return !(
        CookiePolicy.isPersonalisationCookiesEnabled() ||
        CookiePolicy.isAnalyticalCookiesEnabled() ||
        CookiePolicy.isTargetingCookiesEnabled() ||
        CookiePolicy.isSocialMediaCookiesEnabled()
    );
};

const initializeAnalytics = (): void => {
    // Ensure an instance
    EventDataLayer.getInstance();
    initializeAnalyticsInteractions();

    if (
        document.getElementById("one-trust-loader")?.dataset.hasLoaded ===
        "false"
    ) {
        window.addEventListener("onetrustloaded", () => {
            if (!hasOnlyStrictCookies()) {
                subscribe(true);
            }

            window.OneTrust?.OnConsentChanged(() => {
                if (!hasOnlyStrictCookies()) {
                    subscribe(true);
                }
            });
        });
    } else {
        if (!hasOnlyStrictCookies()) {
            subscribe(true);
        }

        window.OneTrust?.OnConsentChanged(() => {
            if (!hasOnlyStrictCookies()) {
                subscribe(true);
            }
        });
    }
};

export { initializeAnalytics };
